import { render, staticRenderFns } from "./CoverageFormDialog.vue?vue&type=template&id=0177c386&"
import script from "./CoverageFormDialog.vue?vue&type=script&lang=js&"
export * from "./CoverageFormDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports